import React from 'react';
import { FormattedMessage } from 'react-intl';

import Select from 'components/mui/Form/Select/SelectBase';

const SplitOptions = ({ onSelect, value }) => {
  const getLabel = (id) => <FormattedMessage id={`document.edit.splitOptions.${id}`}>{(t) => t}</FormattedMessage>;

  const options = ['add', 'add_on_first', 'remove'].map((i) => ({ value: i, label: getLabel(i) }));

  return (
    <Select
      FormControlProps={{ size: 'small', fullWidth: true, sx: { maxWidth: 450 } }}
      MenuProps={{
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      }}
      fullWidth
      value={value}
      options={options}
      onChange={onSelect}
    />
  );
};

export default SplitOptions;
